import { api } from 'lq-ui'

export default (id) => api.post('/proposal/reject', id)
  .then((response) => {
    if (response.ok) return response
    throw response
  })
